import { axiosGet } from '../util/api'
import type { EntityId } from '../types/constants'

/**
 * Load the central/default portfolios page from the inventory-first v5 endpoint.
 * This intentionally has no API-version switch: the default page must include
 * portfolios that have no campaigns or performance rows.
 */
export const loadAmazonPortfolios = (profile: EntityId | null, params: object): Promise<any> => {
    if (!profile) {
        return Promise.resolve()
    }

    return axiosGet('api/v5/portfolios', params, true)
}
